<template>
    <div class="new-popupbox" :class="{ phoneMode }" @click="close()">
        <div class="hanlder-box">
            <svg class="icon-svg popup-close" @click="close()" v-if="!phoneMode">
                <use xlink:href="#icon-guanbi" />
            </svg>
        </div>
        <div class="list-content achievement-box" :style="{ backgroundColor: theme_color }" @click.stop>
            <div class="title">排行榜</div>
            <div class="list-rank" :class="{ 'myScore': userScore?.rank > 5 }">
                <div class="describe">
                    <div class="describe-item">
                        <div class="describe-top">
                            <span>总分</span>
                        </div>
                        <p class="value">{{ userScore?.Score }}</p>
                    </div>
                    <div class="describe-item">
                        <div class="describe-top">
                            <span>完成度</span>
                        </div>
                        <div class="value">
                            <p>{{ userScore?.submitPercent }}</p>
                            <p class="percent">%</p>
                        </div>
                    </div>
                    <div class="describe-item">
                        <div class="describe-top">
                            <span>排名</span>
                        </div>
                        <p class="value">{{ userScore?.rank }}</p>
                    </div>
                </div>
                <div class="ranking-list-box">
                    <div class="ranking-title">
                        <p class="title-name">排名</p>
                        <p class="title-name" id="title-name">姓名</p>
                        <p class="title-name">完成度</p>
                        <p class="title-name">得分</p>
                        <p class="title-name">徽章数</p>
                    </div>
                    <div class="ranking-box">
                        <div class="ranking-list" v-for="item in stuList"
                            :class="{ 'my-background': userScore?.rank == item.rank, 'hide': item.rank > 5 }">
                            <p class="ranking-item">{{ item.rank }}</p>
                            <p class="ranking-item" id="title-name">{{ item.NickName }}</p>
                            <p class="ranking-item">{{ item.submitPercent }}%</p>
                            <p class="ranking-item">{{ item.Score }}</p>
                            <p class="ranking-item">{{ item.achievement?.length || 0 }}</p>
                        </div>
                        <div class="ranking-list my-background" v-if="userScore && userScore?.rank > 5">
                            <p class="ranking-item">{{ userScore.rank }}</p>
                            <p class="ranking-item" id="title-name">{{ userScore.NickName }}</p>
                            <p class="ranking-item">{{ userScore.submitPercent }}%</p>
                            <p class="ranking-item">{{ userScore.Score }}</p>
                            <p class="ranking-item">{{ userScore.achievement?.length || 0 }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 

<script>
export default {
    data() {
        return {
            userScore: null,
            stuList: [],
            theme_color: '#FFD700',
            phoneMode: false,
        }
    },
    async mounted() {
        let { userScore, stuList, platform } = this.$store.state;
        this.theme_color = platform.pageConfig.theme_color;
        this.userScore = userScore;
        this.stuList = stuList;
    },
    methods: {
        //判断手机端
        judgePhone() {
            let w_width = window.innerWidth;
            let phoneMode = w_width < 700;
            if (this.phoneMode == phoneMode) return;

            this.phoneMode = phoneMode;
        },
        close() {
            this.$emit('closeBox');
        }
    },
}
</script>

<style scoped lang="scss">
.new-popupbox {
    overflow-y: overlay;


    &.phoneMode {
        top: 53px;
        height: calc(100% - 106px);

        .achievement-box {
            margin: 0;
            border-radius: 0;
            max-width: 100%;
            padding: 1rem;

            .achievement-list {
                .achievement-item {
                    width: calc(100%/3 - 10px);

                }
            }
        }
    }

    .list-content {
        padding:30px 50px;
        border-radius: 10px;

        .title {
            font-size: 24px;
            font-weight: bold;
        }
    }

    .list-rank {
        width: 400px;
        height: 600px;

        &.myScore {
            height: 420px;
        }

        .describe {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            position: relative;
            padding: 15px 0;

            .describe-item {
                font-size: 50px;
                width: calc(100%/3);
                text-align: center;

                &:not(:last-child) {
                    border-right: 1px #f9f9f969 solid;
                }

                .describe-top {
                    font-size: 1.125rem;

                    >img {
                        position: relative;
                        top: 3px;
                        margin-right: 5px;
                        width: 25px;
                        height: 25px;
                    }
                }

                .value {
                    display: flex;
                    flex-direction: row;
                    align-items: baseline;
                    justify-content: center;
                    margin-bottom: 0;
                    position: relative;
                    font-family: Agency FB;
                    font-weight: bold;
                    line-height: 1;

                    .percent {
                        font-size: 20px;
                    }

                    >p {
                        margin-bottom: 0;
                    }
                }
            }

            .title-content {
                position: relative;
                right: -275px;
                width: 300px;
                padding-top: 0.625px;
            }
        }

        .ranking-list-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 16px;
            height: calc(100% - 108px);

            img {
                height: 15px;
                width: 357px;
            }

            .ranking-name-box {
                display: flex;
                flex-direction: row;
                width: 100%;
                font-size: 1.125rem;
                padding: 0 14px;

                p {
                    text-align: left;
                    margin: 0;
                }

                img {
                    margin-right: 5px;
                    position: relative;
                    top: 3px;
                    height: 27px;
                    width: 27px;
                }
            }

            .ranking-title {
                display: flex;
                flex-direction: row;
                justify-content: center;
                width: 100%;
                border-bottom: 1px #fff solid;

                .title-name {
                    text-align: center;
                    width: calc(100%/4);
                    margin: 10px 0;
                }
            }

            .ranking-box {
                width: 100%;
            }

            .ranking-list {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 32px;
                margin-top: 6px;

                &.hide {
                    display: none;
                }

                .ranking-item {
                    text-align: center;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    width: calc(100%/4);
                    margin-bottom: 7px;

                    .name {
                        text-align: start;
                    }
                }
            }

            .my-background {
                background-color: #ffffff2e;
            }
        }
    }
}
</style>